import { PocStep } from 'commons/components/components-wrapper';
import styled from 'styled-components';

/* OWC-OVERRIDE: a display-only step must not look clickable; suppress owc's hover fill on
   the label. owc-step has no non-interactive prop in v7.6.0. Revisit on the next @one upgrade. */
export const NoClickableStep = styled(PocStep)`
    &.owc-step:hover {
        .owc-step__slot-wrapper {
            background-color: unset;
        }
    }
`;
